import api from "./client";

// Call Observations API
export const callObservationsAPI = {
  getCallObservations: async (clientId, params = {}) => {
    const response = await api.get(`/api/v1/clients/${clientId}/call_observations`, {
      params: params,
    });
    return response;
  },

  getCallObservation: async (clientId, id) => {
    const response = await api.get(`/api/v1/clients/${clientId}/call_observations/${id}`);
    return response;
  },

  createCallObservation: async (clientId, data) => {
    const response = await api.post(`/api/v1/clients/${clientId}/call_observations`, data);
    return response;
  },

  uploadCallFiles: async (clientId, files, options = {}) => {
    const formData = new FormData();

    // Add multiple files
    if (Array.isArray(files)) {
      files.forEach((file) => {
        formData.append("recording_files[]", file);
      });
    } else {
      formData.append("recording_file", files);
    }

    // Add optional parameters
    if (options.agent_id) {
      formData.append("agent_id", options.agent_id);
    }
    if (options.label) {
      formData.append("label", options.label);
    }
    if (options.call_direction) {
      formData.append("call_direction", options.call_direction);
    }
    if (options.metadata) {
      formData.append("metadata", JSON.stringify(options.metadata));
    }

    const response = await api.post(
      `/api/v1/clients/${clientId}/call_observations`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  },

  updateCallObservation: async (clientId, id, data) => {
    const response = await api.patch(
      `/api/v1/clients/${clientId}/call_observations/${id}`,
      data
    );
    return response;
  },

  deleteCallObservation: async (clientId, id) => {
    const response = await api.delete(`/api/v1/clients/${clientId}/call_observations/${id}`);
    return response;
  },
};

// Production Observability API — ingest and analyze real call recordings
export const observabilityAPI = {
  getCalls: async (params = {}) => {
    const response = await api.get('/api/v1/observability/calls', { params });
    return response;
  },

  getCall: async (id) => {
    const response = await api.get(`/api/v1/observability/calls/${id}`);
    return response;
  },

  ingestCall: async (callData) => {
    const response = await api.post('/api/v1/observability/calls', { call: callData });
    return response;
  },

  rerunAllMetrics: async (id) => {
    const response = await api.post(`/api/v1/observability/calls/${id}/rerun_all`);
    return response;
  },

  rerunAudioMetrics: async (id) => {
    const response = await api.post(`/api/v1/observability/calls/${id}/rerun_audio`);
    return response;
  },

  rerunLlmMetrics: async (id) => {
    const response = await api.post(`/api/v1/observability/calls/${id}/rerun_llm`);
    return response;
  },

  rerunSelectedMetrics: async (id, metricIds) => {
    const response = await api.post(
      `/api/v1/observability/calls/${id}/rerun_selected`,
      { metric_ids: metricIds }
    );
    return response;
  },

  updateAgentStandardMetrics: async (clientId, agentId, disabledMetricKeys) => {
    const response = await api.put(
      `/api/v1/agents/${agentId}/standard_metrics`,
      { disabled_metric_keys: disabledMetricKeys },
      { params: { client_id: clientId } }
    );
    return response;
  },

  updateAgentLlmMetrics: async (clientId, agentId, disabledLlmMetricIds) => {
    const response = await api.put(
      `/api/v1/agents/${agentId}/llm_metrics`,
      { disabled_llm_metric_ids: disabledLlmMetricIds },
      { params: { client_id: clientId } }
    );
    return response;
  },
};
